import { Button, Drawer, Flex, Grid, Image, Page, Typography } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import { Close } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { Link, useNavigate } from "react-router-dom";
import { useAppTranslation } from "@/utils";
import { closeId, ctaId } from "@/assets/googleTrackIds";
import { URLS } from "@payping/utilities-shared/consts";

const SuccesFul = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const { md } = Grid.useBreakpoint();
  return (
    <>
      <Drawer
        title={<Typography.Text>{t("digitalAccount.termsAndCondition.samanBankAccountOpeningForm")}</Typography.Text>}
        open={true}
        closable={false}
        height={"100%"}
        placement={"bottom"}
        extra={
          <Button
            type={"text"}
            icon={<Close width={14} height={14} />}
            onClick={() => {
              navigate(DashboardRoutes.digitalAccount.home?.url);
            }}
            data-google-track={closeId}
          />
        }
      >
        <Page>
          <SubLayout>
            <Flex vertical gap={32}>
              <div className="!tw-flex !tw-justify-center">
                <Image src={`${URLS.STORAGE_URL}/img/Succesful.png`} preview={false} height={128} width={128} />
              </div>
              <Typography.Text className="!tw-flex !tw-justify-center tw-whitespace-pre-line">
                {t("digitalAccount.success.successDesc")}
              </Typography.Text>
              {md ? (
                <div className="!tw-flex !tw-justify-center">
                  <Link to={DashboardRoutes.digitalAccount.yourAccount.url}>
                    <Button className="tw-w-fit" type={"primary"} data-google-track={ctaId}>
                      {t("digitalAccount.success.iRealized")}
                    </Button>
                  </Link>
                </div>
              ) : null}
            </Flex>
          </SubLayout>
        </Page>
      </Drawer>
      {!md ? (
        <Drawer open={true} closeIcon={false} mask={false} height={80} placement={"bottom"}>
          <Button className="tw-w-full" block type={"primary"} data-google-track={ctaId}>
            {t("digitalAccount.success.iRealized")}
          </Button>
        </Drawer>
      ) : null}
    </>
  );
};

export default SuccesFul;
